import React from 'react'
import PropTypes from 'prop-types'
import { TcQuickView } from '@tc-packages/tc-common'

const TCQuickViewWrapper = ({ id, buttonStyles, config, cartType }) => (
  <TcQuickView buttonStyles={buttonStyles} cartType={cartType} config={config} id={id} />
)

TCQuickViewWrapper.propTypes = {
  buttonStyles: PropTypes.object,
  cartType: PropTypes.string,
  config: PropTypes.object.isRequired,
  id: PropTypes.number,
}

export default TCQuickViewWrapper
